import "./styles.scss";

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

function Pagination({ totalPages = 0, totalFound = 20, pageCurrent = 1, totalResults = 0, onClick }) {
  const { t } = useTranslation();

  const [saveTotalFound, setSaveTotalFound] = useState(totalFound);
  const [saveInitialFound, setSaveInitialFound] = useState(1);

  let maxPage;
  let minPage;
  const pages = [];
  const maxShowPage = 11;

  function calculatePage(paginaAtual, itensPorPagina, totalItens) {
    const start = (paginaAtual - 1) * itensPorPagina + 1;
    const end = Math.min(start + itensPorPagina - 1, totalItens);

    return [start, end];
  }

  const navigation = (page, totalFound, totalResults) => {
    page = page > totalPages ? totalPages : page;
    page = page < 1 ? 1 : page;

    const [start, end] = calculatePage(Number(page), Number(totalFound), Number(totalResults));
    setSaveTotalFound(end);
    setSaveInitialFound(start);

    onClick(page);
    window.history.pushState("Object", "Categoria JavaScript", "?page=" + page);
  };

  maxPage = maxShowPage > totalPages ? totalPages : maxShowPage;
  maxPage = pageCurrent + (maxShowPage - 1) / 2 > totalPages ? totalPages : pageCurrent + (maxShowPage - 1) / 2;
  minPage = pageCurrent - (maxShowPage - 1) / 2 < 1 ? 1 : pageCurrent - (maxShowPage - 1) / 2;

  for (let i = minPage; i <= maxPage; i++) {
    pages.push(i);
  }

  useEffect(() => {
    navigation(1, totalFound, totalResults);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="boxPagination">
      <span>
        {t("SHOWING")} {saveInitialFound}-{saveTotalFound} {t("SHOWING_OF")} {totalResults || saveTotalFound}
      </span>

      <ul className="pagination">
        {pageCurrent > 1 && (
          <li>
            <a onClick={() => navigation(1, totalFound, totalResults)}>
              <i className="fa fa-angle-double-left" aria-hidden="true"></i>
            </a>
          </li>
        )}

        <li>
          <a onClick={() => navigation(pageCurrent - 1, totalFound, totalResults)}>
            <i className="fa fa-angle-left" aria-hidden="true"></i>
          </a>
        </li>

        {pages &&
          pages.map((item, i) => {
            return (
              <li key={"page" + i}>
                <a
                  onClick={() => navigation(item, totalFound, totalResults)}
                  className={pageCurrent === item ? "active" : ""}
                >
                  {item}
                </a>
              </li>
            );
          })}

        <li>
          <a onClick={() => navigation(pageCurrent + 1, totalFound, totalResults)}>
            <i className="fa fa-angle-right" aria-hidden="true"></i>
          </a>
        </li>

        {pageCurrent < totalPages && (
          <li>
            <a onClick={() => navigation(totalPages, totalFound, totalResults)}>
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}

export default Pagination;
